import { render, staticRenderFns } from "./PillsSelect.vue?vue&type=template&id=c4c8b5c6"
import script from "./PillsSelect.vue?vue&type=script&lang=ts"
export * from "./PillsSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports